import { render, staticRenderFns } from "./TradersFeesAndRates.vue?vue&type=template&id=bd425672&"
import script from "./TradersFeesAndRates.vue?vue&type=script&lang=js&"
export * from "./TradersFeesAndRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports